var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCt3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 4,
    fill: "#FFF6EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_7054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4716 20.9485C35.525 21.1523 34.6374 21.9895 33.993 21.9895C33.3485 21.9895 32.4609 21.1522 31.5144 20.9485C29.5064 20.6858 26.6562 22.0886 26.6562 26.4014C26.6562 30.7142 29.7794 34.2338 31.1178 34.2338C32.605 34.2338 32.8033 33.5398 33.993 33.5398C35.1827 33.5398 35.381 34.2338 36.8681 34.2338C38.2066 34.2338 41.3296 30.7142 41.3296 26.4014C41.3296 22.0886 38.4796 20.6857 36.4716 20.9485Z",
    fill: "url(#paint0_radial_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4964 20.9569C37.1439 20.9072 36.7977 20.9059 36.4736 20.9483C35.527 21.1521 34.6394 21.9893 33.9949 21.9893C33.9786 21.9893 33.9619 21.9884 33.9453 21.9874V23.0369L34.8234 23.2006L40.8671 24.3275L37.4964 20.9569Z",
    fill: "url(#paint1_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4703 20.9485C35.5238 21.1523 34.6362 21.9895 33.9917 21.9895C33.9587 21.9895 33.9249 21.9868 33.8906 21.9826C34.0329 22.3227 34.1796 22.5631 34.232 22.6446C34.2307 22.6499 34.2293 22.6552 34.228 22.6606L34.252 22.6752L34.2761 22.6897L40.8722 29.2828C41.1548 28.3902 41.3284 27.4178 41.3284 26.4014C41.3284 22.0886 38.4783 20.6857 36.4703 20.9485Z",
    fill: "url(#paint2_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2544 22.6743C34.2544 22.6743 31.2269 18.2558 37.91 17.009C38.1889 16.957 38.4582 17.1361 38.5216 17.4126C38.8264 18.7421 39.1949 22.3685 34.2544 22.6743Z",
    fill: "url(#paint3_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5172 17.4135C38.4821 17.2602 38.3835 17.1371 38.2552 17.0664C36.0411 19.4808 34.25 22.6752 34.25 22.6752C39.1905 22.3694 38.822 18.743 38.5172 17.4135Z",
    fill: "url(#paint4_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4148 19.0498C37.3631 19.0682 37.31 19.0829 37.2578 19.0981C37.2056 19.1134 37.1536 19.1287 37.101 19.1411C37.0487 19.1546 36.9941 19.1606 36.9405 19.1674C36.8869 19.1741 36.8365 19.1888 36.7878 19.2114C36.7398 19.2347 36.6924 19.2601 36.6452 19.2918C36.6845 19.2289 36.7237 19.1659 36.763 19.1028L36.9586 18.7973C37.0234 18.6949 37.0938 18.5975 37.1602 18.4961C37.2962 18.296 37.4389 18.1026 37.5955 17.9182L37.5573 17.877L37.4175 17.9974L37.3471 18.0581C37.3243 18.0789 37.3031 18.1008 37.281 18.1222C37.1951 18.2095 37.1042 18.2943 37.023 18.3856C36.8545 18.5646 36.696 18.7511 36.536 18.9372C36.5061 18.9737 36.4762 19.0104 36.4463 19.047C36.4464 19.0077 36.4437 18.9686 36.4345 18.9296C36.4224 18.8769 36.4091 18.8237 36.4038 18.7699C36.3972 18.7162 36.3936 18.6623 36.3898 18.608C36.3859 18.5537 36.3814 18.4988 36.3807 18.444C36.3743 18.3335 36.3783 18.2228 36.3793 18.1088L36.349 18.1013C36.2998 18.2047 36.2582 18.3128 36.2259 18.4242C36.2091 18.4797 36.1963 18.5362 36.1827 18.5931C36.1722 18.6501 36.1615 18.7076 36.154 18.7655C36.1459 18.8233 36.1344 18.8816 36.1255 18.9405C36.1179 18.9994 36.1203 19.0585 36.135 19.1161C36.138 19.1274 36.1413 19.1387 36.1447 19.1499C36.1823 19.2723 36.1552 19.4055 36.0763 19.5064L36.0749 19.5083C35.9377 19.684 35.8047 19.8622 35.6706 20.04C35.6695 19.9847 35.6637 19.9326 35.6556 19.8812C35.6464 19.8283 35.6299 19.7784 35.6047 19.7306C35.5798 19.6826 35.5536 19.6344 35.5349 19.5837C35.5151 19.5334 35.4981 19.482 35.4809 19.4304C35.4636 19.3788 35.4454 19.3268 35.431 19.2738C35.3972 19.1684 35.3734 19.0603 35.3457 18.9497L35.3144 18.95C35.2927 19.0625 35.2795 19.1776 35.2761 19.2934C35.2738 19.3515 35.2755 19.4093 35.2766 19.4678C35.2807 19.5256 35.2848 19.584 35.2919 19.6419C35.2986 19.6999 35.3021 19.7592 35.3082 19.8185C35.3156 19.8775 35.3327 19.9341 35.3614 19.9861C35.3743 20.009 35.3882 20.0316 35.4034 20.0536C35.4775 20.1608 35.4692 20.305 35.3894 20.408C35.3208 20.4964 35.2521 20.5848 35.1842 20.6737C35.098 20.7862 35.0179 20.9027 34.9424 21.0221C34.9404 20.9746 34.9351 20.9291 34.9281 20.8841C34.919 20.8312 34.9024 20.7814 34.8772 20.7335C34.8524 20.6856 34.8261 20.6374 34.8075 20.5867C34.7876 20.5363 34.7706 20.485 34.7534 20.4333C34.7361 20.3817 34.7179 20.3297 34.7035 20.2768C34.6697 20.1714 34.6459 20.0632 34.6182 19.9526L34.587 19.9529C34.5653 20.0654 34.552 20.1805 34.5486 20.2963C34.5463 20.3544 34.548 20.4122 34.5491 20.4707C34.5532 20.5286 34.5573 20.5869 34.5644 20.6448C34.5712 20.7029 34.5746 20.7622 34.5808 20.8215C34.5882 20.8804 34.6052 20.937 34.6339 20.989C34.663 21.0405 34.697 21.0905 34.7398 21.1354C34.7889 21.1868 34.8015 21.2625 34.7689 21.3256C34.6844 21.489 34.5342 21.7857 34.4652 21.9489C34.3707 22.1769 34.2843 22.4097 34.2266 22.6594L34.2746 22.6886C34.4696 22.5234 34.6399 22.3437 34.8021 22.1594C34.9637 21.9746 35.1157 21.7843 35.2595 21.589C35.2621 21.5855 35.2646 21.5821 35.2672 21.5786C35.3136 21.5156 35.3961 21.4957 35.4685 21.5253C35.5219 21.5472 35.5766 21.5605 35.6312 21.5693C35.69 21.5782 35.749 21.5746 35.8068 21.5612C35.8645 21.5464 35.9214 21.5292 35.9782 21.5154C36.035 21.5021 36.0912 21.4857 36.1468 21.4695C36.202 21.4503 36.2569 21.4319 36.3106 21.4096C36.4181 21.3663 36.5215 21.3141 36.6195 21.2548L36.6089 21.2254C36.4956 21.2377 36.3859 21.2528 36.2753 21.2575C36.2207 21.2624 36.1656 21.2633 36.1112 21.2649C36.0568 21.2667 36.0027 21.2685 35.9486 21.2673C35.8946 21.2674 35.8402 21.2595 35.7867 21.2527C35.7331 21.2457 35.6806 21.2474 35.6278 21.2571C35.5707 21.2685 35.5138 21.2833 35.455 21.305C35.5237 21.1981 35.5888 21.0888 35.6503 20.9774C35.6987 20.8878 35.7653 20.7679 35.8242 20.6627C35.8867 20.5508 36.014 20.4883 36.1395 20.5143C36.2009 20.527 36.2637 20.5306 36.3204 20.5399C36.3792 20.5488 36.4382 20.5452 36.496 20.5317C36.5537 20.517 36.6106 20.4997 36.6673 20.4859C36.7242 20.4726 36.7803 20.4562 36.836 20.44C36.8912 20.4209 36.9461 20.4024 36.9998 20.3802C37.1072 20.3369 37.2107 20.2846 37.3087 20.2253L37.2981 20.1959C37.1848 20.2082 37.0751 20.2234 36.9645 20.2281C36.9099 20.233 36.8548 20.2338 36.8004 20.2355C36.746 20.2372 36.6919 20.2391 36.6378 20.2379C36.5838 20.2379 36.5294 20.23 36.4758 20.2232C36.4223 20.2162 36.3697 20.2179 36.317 20.2276C36.2165 20.2478 36.1165 20.2774 36.0053 20.3411C36.1303 20.1343 36.2537 19.926 36.3817 19.7213L36.3865 19.7132C36.4616 19.5869 36.5994 19.5069 36.7461 19.5157C36.7876 19.5182 36.8285 19.5167 36.8688 19.513C36.9279 19.5069 36.9841 19.4886 37.0368 19.4611C37.089 19.4325 37.1397 19.4015 37.1912 19.3739C37.2429 19.3468 37.2932 19.317 37.343 19.2873C37.3917 19.2549 37.4402 19.2233 37.4866 19.1883C37.5798 19.1195 37.6669 19.043 37.7469 18.9611L37.7294 18.9353C37.6231 18.9755 37.5207 19.0176 37.4148 19.0498Z",
    fill: "url(#paint5_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3579 23.0808C34.2285 23.0917 34.0951 23.0976 33.9594 23.0976C33.8637 23.0976 33.7697 23.0949 33.6771 23.089C33.6658 22.4314 33.5936 21.6246 33.3767 20.8177C33.2478 20.3371 33.0672 19.856 32.8171 19.4063C32.3942 18.6462 31.9662 18.3313 31.9617 18.3281C31.8101 18.2183 31.7747 18.0064 31.8832 17.8539C31.9922 17.7019 32.2023 17.6651 32.3552 17.7726C32.4174 17.8162 33.5351 18.6294 34.0733 20.7827C34.2344 21.4248 34.3433 22.1854 34.3579 23.0808Z",
    fill: "url(#paint6_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6263 22.2715C36.5284 22.3445 36.4278 22.4062 36.3245 22.4607C36.2194 22.5127 36.114 22.5599 36.0054 22.5996C35.7893 22.6804 35.566 22.7383 35.3414 22.7841C34.8915 22.8748 34.4325 22.913 33.9734 22.9134C33.5151 22.9118 33.0547 22.8745 32.6053 22.7839C32.3801 22.7392 32.1581 22.6787 31.9417 22.5987C31.8322 22.5606 31.7281 22.5114 31.6222 22.4605C31.5715 22.4324 31.5181 22.4058 31.4696 22.3726C31.417 22.3435 31.3714 22.306 31.3203 22.2715C31.3885 22.3891 31.478 22.4944 31.5791 22.5888L35.9453 26.955C36.0477 27.0663 36.1677 27.1639 36.2938 27.248C36.5016 27.3868 36.7291 27.4944 36.9637 27.5771C37.4346 27.7419 37.931 27.8146 38.4268 27.8155C38.9216 27.8148 39.4195 27.741 39.8897 27.5762C40.1238 27.4922 40.3521 27.3873 40.5597 27.2479C40.7656 27.1091 40.9571 26.937 41.0797 26.7249L36.6263 22.2715Z",
    fill: "url(#paint7_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6263 22.2715C36.5037 22.4836 36.3122 22.6557 36.1062 22.7945C35.8986 22.9339 35.6704 23.0388 35.4362 23.1228C34.9661 23.2876 34.4681 23.3614 33.9734 23.3621C33.4776 23.3612 32.9812 23.2885 32.5102 23.1237C32.2756 23.0411 32.0481 22.9334 31.8403 22.7946C31.6338 22.6568 31.443 22.4833 31.3203 22.2715C31.3714 22.306 31.417 22.3434 31.4696 22.3726C31.5182 22.4058 31.5715 22.4324 31.6222 22.4605C31.7281 22.5114 31.8321 22.5606 31.9417 22.5987C32.1581 22.6787 32.3801 22.7392 32.6053 22.7839C33.0547 22.8745 33.5151 22.9118 33.9734 22.9134C34.4326 22.9131 34.8915 22.8748 35.3415 22.7841C35.5662 22.7383 35.7893 22.6805 36.0054 22.5996C36.114 22.5599 36.2195 22.5127 36.3246 22.4607C36.4278 22.4062 36.5284 22.3445 36.6263 22.2715Z",
    fill: "url(#paint8_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3236 30.3744C33.5129 30.3744 35.2877 28.3655 35.2877 25.8874C35.2877 23.4093 33.5129 21.4004 31.3236 21.4004C29.1342 21.4004 27.3594 23.4093 27.3594 25.8874C27.3594 28.3655 29.1342 30.3744 31.3236 30.3744Z",
    fill: "url(#paint9_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4731 44.8663V48.2123C46.4731 48.6476 46.1202 49.0005 45.6849 49.0005H23.9771C23.2976 49.0005 22.6821 48.725 22.2366 48.2795C21.7911 47.8341 21.5156 47.2185 21.5156 46.539C21.5156 45.1799 22.6174 44.0781 23.9771 44.0781H45.685C46.1202 44.0782 46.4731 44.4311 46.4731 44.8663Z",
    fill: "url(#paint10_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4731 44.8663V48.2123C46.4731 48.6476 46.1202 49.0005 45.6849 49.0005H23.9771C23.2976 49.0005 22.6821 48.725 22.2366 48.2795C21.7911 47.8341 21.5156 47.2185 21.5156 46.539C21.5156 45.1799 22.6174 44.0781 23.9771 44.0781H45.685C46.1202 44.0782 46.4731 44.4311 46.4731 44.8663Z",
    fill: "url(#paint11_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6981 48.4035H24.1383C23.1084 48.4035 22.2734 47.5686 22.2734 46.5387C22.2734 45.5088 23.1083 44.6738 24.1383 44.6738H44.8029C45.2031 44.6738 45.5276 44.9983 45.5276 45.3985V47.574C45.5276 48.0321 45.1562 48.4035 44.6981 48.4035Z",
    fill: "url(#paint12_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4922 47.4102C22.8052 48.0008 23.4258 48.4034 24.1408 48.4034H44.7005C45.1587 48.4034 45.5301 48.032 45.5301 47.5739V47.4102H22.4922V47.4102Z",
    fill: "url(#paint13_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1382 48.4039H44.698C45.1561 48.4039 45.5275 48.0325 45.5275 47.5744V46.5391H22.2734C22.2734 47.569 23.1083 48.4039 24.1382 48.4039Z",
    fill: "url(#paint14_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4806 45.6855C22.3485 45.9414 22.2734 46.2316 22.2734 46.5394C22.2734 47.5693 23.1083 48.4042 24.1383 48.4042H44.698C45.1562 48.4042 45.5276 48.0328 45.5276 47.5747V45.6856H22.4806V45.6855Z",
    fill: "url(#paint15_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4989 45.6855L32.7695 48.9561H25.0547V45.6855H29.4989Z",
    fill: "url(#paint16_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8672 45.6855V48.8844C24.8672 48.9782 24.9726 49.0332 25.0495 48.9796L26.9611 47.6477C27.0929 47.5558 27.2679 47.5558 27.3997 47.6477L29.3114 48.9796C29.3883 49.0332 29.4936 48.9782 29.4936 48.8844V45.6855H24.8672Z",
    fill: "url(#paint17_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0781 39.9425V43.2885C22.0781 43.7238 22.431 44.0767 22.8663 44.0767H44.0264C44.706 44.0767 45.3215 43.8012 45.767 43.3557C46.2125 42.9102 46.4879 42.2947 46.4879 41.6152C46.4879 40.2561 45.3861 39.1543 44.0264 39.1543H22.8663C22.431 39.1544 22.0781 39.5072 22.0781 39.9425Z",
    fill: "url(#paint18_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8663 39.1562H31.1343C30.699 39.1562 30.3462 39.5091 30.3462 39.9444V43.2904C30.3462 43.7257 30.6991 44.0785 31.1343 44.0785H22.8663C22.4309 44.0785 22.0781 43.7257 22.0781 43.2904V39.9444C22.0781 39.5091 22.431 39.1562 22.8663 39.1562Z",
    fill: "url(#paint19_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3608 43.4817H43.8624C44.8923 43.4817 45.7272 42.6468 45.7272 41.6168C45.7272 40.5869 44.8923 39.752 43.8624 39.752H22.256C21.8557 39.752 21.5312 40.0764 21.5312 40.4767V42.6521C21.5312 43.1103 21.9027 43.4817 22.3608 43.4817Z",
    fill: "url(#paint20_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5109 42.4883C45.1979 43.0789 44.5773 43.4815 43.8624 43.4815H22.3608C21.9026 43.4815 21.5312 43.1101 21.5312 42.652V42.4883H45.5109V42.4883Z",
    fill: "url(#paint21_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8624 43.482H22.3608C21.9026 43.482 21.5312 43.1106 21.5312 42.6525V41.6172H45.7271C45.7271 42.6471 44.8923 43.482 43.8624 43.482Z",
    fill: "url(#paint22_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.52 40.7617C45.6521 41.0176 45.7271 41.3077 45.7271 41.6156C45.7271 42.6455 44.8923 43.4804 43.8623 43.4804H22.3608C21.9026 43.4804 21.5312 43.109 21.5312 42.6509V40.7618H45.52V40.7617Z",
    fill: "url(#paint23_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2404 39.752H30.3692C30.3538 39.8134 30.3447 39.8775 30.3447 39.9438V43.2898C30.3447 43.356 30.3538 43.4201 30.3692 43.4816H22.3452C21.887 43.4816 21.5156 43.1102 21.5156 42.652V40.4766C21.5157 40.0764 21.8401 39.752 22.2404 39.752Z",
    fill: "url(#paint24_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9254 35.0206V38.3666C45.9254 38.8019 45.5725 39.1548 45.1373 39.1548H23.9771C23.2976 39.1548 22.6821 38.8793 22.2366 38.4338C21.7911 37.9883 21.5156 37.3728 21.5156 36.6933C21.5156 35.3342 22.6174 34.2324 23.9771 34.2324H45.1373C45.5725 34.2324 45.9254 34.5853 45.9254 35.0206Z",
    fill: "url(#paint25_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1397 39.1547C45.575 39.1547 45.9278 38.8018 45.9278 38.3666V35.0206C45.9278 34.5852 45.5749 34.2324 45.1397 34.2324H30.8281L35.7505 39.1548H45.1397V39.1547Z",
    fill: "url(#paint26_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1352 34.2324H36.8672C37.3025 34.2324 37.6553 34.5853 37.6553 35.0206V38.3666C37.6553 38.8018 37.3024 39.1547 36.8672 39.1547H45.1352C45.5705 39.1547 45.9234 38.8018 45.9234 38.3666V35.0206C45.9234 34.5853 45.5705 34.2324 45.1352 34.2324Z",
    fill: "url(#paint27_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6398 38.5598H24.1383C23.1084 38.5598 22.2734 37.7249 22.2734 36.6949C22.2734 35.665 23.1083 34.8301 24.1383 34.8301H45.7446C46.1449 34.8301 46.4693 35.1545 46.4693 35.5548V37.7302C46.4693 38.1884 46.0979 38.5598 45.6398 38.5598Z",
    fill: "url(#paint28_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4922 37.5664C22.8052 38.157 23.4258 38.5596 24.1408 38.5596H45.6422C46.1004 38.5596 46.4718 38.1882 46.4718 37.7301V37.5665H22.4922V37.5664Z",
    fill: "url(#paint29_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1382 38.5581H45.6397C46.0979 38.5581 46.4693 38.1868 46.4693 37.7287V36.6934H22.2734C22.2734 37.7233 23.1083 38.5581 24.1382 38.5581Z",
    fill: "url(#paint30_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4806 35.8398C22.3485 36.0957 22.2734 36.3859 22.2734 36.6937C22.2734 37.7236 23.1083 38.5585 24.1383 38.5585H45.6398C46.0979 38.5585 46.4693 38.1871 46.4693 37.729V35.8399H22.4806V35.8398Z",
    fill: "url(#paint31_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4219 34.8301L35.1515 38.5598H45.6434C45.7372 38.5598 45.827 38.5434 45.9111 38.5148C45.92 38.4671 45.9252 38.4182 45.9252 38.3679V35.022C45.9252 34.962 45.918 34.9038 45.9053 34.8476C45.8546 34.8365 45.8022 34.8301 45.7482 34.8301H31.4219V34.8301Z",
    fill: "url(#paint32_linear_170_7054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7616 34.8301H37.6328C37.6482 34.8916 37.6573 34.9556 37.6573 35.0219V38.3679C37.6573 38.4342 37.6482 38.4982 37.6328 38.5597H45.6568C46.1149 38.5597 46.4863 38.1883 46.4863 37.7302V35.5547C46.4863 35.1545 46.1619 34.8301 45.7616 34.8301Z",
    fill: "url(#paint33_linear_170_7054)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_170_7054",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5746 24.3505) scale(10.7717 10.7717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2389,
    stopColor: "#FF6C41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#FE603A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7053,
    stopColor: "#FC4D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9351,
    stopColor: "#FA311A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_7054",
    x1: 37.2278,
    y1: 23.0623,
    x2: 36.3957,
    y2: 20.1703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1D25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1D25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_7054",
    x1: 38.017,
    y1: 23.967,
    x2: 35.1551,
    y2: 18.9509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_7054",
    x1: 35.778,
    y1: 19.4969,
    x2: 39.1182,
    y2: 22.0359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_170_7054",
    x1: 37.733,
    y1: 20.6907,
    x2: 34.8343,
    y2: 19.0772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_170_7054",
    x1: 35.2585,
    y1: 19.7378,
    x2: 36.0699,
    y2: 20.4099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_170_7054",
    x1: 31.8203,
    y1: 20.4042,
    x2: 34.3579,
    y2: 20.4042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_170_7054",
    x1: 36.7948,
    y1: 25.7841,
    x2: 33.9157,
    y2: 19.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_170_7054",
    x1: 33.9733,
    y1: 21.9424,
    x2: 33.9733,
    y2: 23.5386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_170_7054",
    x1: 32.0062,
    y1: 26.3476,
    x2: 24.2113,
    y2: 21.0935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#FF813A",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7194,
    stopColor: "#FF9A2B",
    stopOpacity: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_170_7054",
    x1: 29.9195,
    y1: 41.8553,
    x2: 43.3939,
    y2: 55.7015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_170_7054",
    x1: 33.9183,
    y1: 44.8646,
    x2: 34.483,
    y2: 51.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_170_7054",
    x1: 33.9005,
    y1: 45.2352,
    x2: 33.9005,
    y2: 48.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_170_7054",
    x1: 33.9746,
    y1: 48.4402,
    x2: 34.1419,
    y2: 44.1316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_170_7054",
    x1: 33.9005,
    y1: 47.4525,
    x2: 33.9005,
    y2: 45.2774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_170_7054",
    x1: 33.9207,
    y1: 46.3617,
    x2: 33.9625,
    y2: 44.9394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_170_7054",
    x1: 28.9395,
    y1: 49.0643,
    x2: 28.1709,
    y2: 46.0369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_170_7054",
    x1: 26.1295,
    y1: 45.9377,
    x2: 29.2603,
    y2: 50.0102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_170_7054",
    x1: 35.75,
    y1: 37.7848,
    x2: 32.0476,
    y2: 45.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_170_7054",
    x1: 23.7277,
    y1: 41.6174,
    x2: 34.5645,
    y2: 41.6174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_170_7054",
    x1: 33.6292,
    y1: 40.3133,
    x2: 33.6292,
    y2: 43.4226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_170_7054",
    x1: 33.558,
    y1: 43.5296,
    x2: 33.3874,
    y2: 39.1347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_170_7054",
    x1: 33.6292,
    y1: 42.5306,
    x2: 33.6292,
    y2: 40.3555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_170_7054",
    x1: 33.6089,
    y1: 41.4324,
    x2: 33.5666,
    y2: 39.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_170_7054",
    x1: 23.8221,
    y1: 41.6168,
    x2: 39.2511,
    y2: 41.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_170_7054",
    x1: 32.2536,
    y1: 32.8629,
    x2: 35.956,
    y2: 40.8847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_170_7054",
    x1: 39.7694,
    y1: 38.7047,
    x2: 35.5654,
    y2: 26.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_170_7054",
    x1: 44.2738,
    y1: 36.6936,
    x2: 33.437,
    y2: 36.6936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_170_7054",
    x1: 34.3714,
    y1: 35.3915,
    x2: 34.3714,
    y2: 38.5007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_170_7054",
    x1: 34.4451,
    y1: 38.6077,
    x2: 34.6157,
    y2: 34.2129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_170_7054",
    x1: 34.3714,
    y1: 37.6069,
    x2: 34.3714,
    y2: 35.4317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_170_7054",
    x1: 34.3918,
    y1: 36.5106,
    x2: 34.4339,
    y2: 35.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_170_7054",
    x1: 40.9473,
    y1: 38.5686,
    x2: 31.8807,
    y2: 23.7608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_170_7054",
    x1: 44.1799,
    y1: 36.6949,
    x2: 28.7509,
    y2: 36.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_7054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt3);
export default __webpack_public_path__ + "static/media/ct3.3108f47ca81f8293b55bf659d33492e4.svg";
export { ForwardRef as ReactComponent };